const envOrDefault = (envName: string, defaultVaue: string) => {
    const chiave = 'REACT_APP_' + envName
    return (process.env[chiave] ? process.env[chiave]! : defaultVaue)
}

export const ApplicationName = envOrDefault('NAME', 'SixActivator')
export const ApplicationDescri = envOrDefault('TITLE', '')

const constants = {
    baseUrl: envOrDefault('BASE_URL', ''),
    apiUrl: envOrDefault('API_URL', ''),
    loginUrl: envOrDefault('LOGIN_URL', `/Account/Login`),
    logoutUrl: envOrDefault('LOGOUT_URL', `/Account/Logout`),
    // baseUrl: envOrDefault('BASE_URL', 'https://localhost:3020'),
    // apiUrl: envOrDefault('API_URL', 'https://localhost:44359'),
    // loginUrl: envOrDefault('LOGIN_URL', `https://localhost:44359/Account/Login`),
    // logoutUrl: envOrDefault('LOGOUT_URL', `https://localhost:44359/Account/Logout`)
    ambiente: envOrDefault('AMBIENTE', `DEV`),
    ambColor: envOrDefault('AMB_COLOR', `darkred`),
    ambLabelColor: envOrDefault('AMB_LABEL_COLOR', `gold`),
}

export const preferitoCardColors = [
    "#f44336", "#e91e63", "#9c27b0", "#673ab7",
    "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4",
    "#009688", "#4caf50", "#8bc34a", "#cddc39",
    "#ffeb3b", "#ffc107", "#ff9800", "#ff5722",
    "#795548", "#607d8b", "#e0e0e0", "#000000"
]

export const prefStarColor = '#ffc107'
export const notPrefStarColor = '#c0c0c0'
export const headerHeight = 60
export const preferitoCardColorsWidth = '240px'

export const dndBorderActive = 'solid 2px blue'
export const dndBorderInactive = 'solid 2px rgba(255,255,255,0)'

export default constants